"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Curry = Curry;
exports.CurryProcess = CurryProcess;

var _reactPureCheck = require("react-pure-check");

function Curry(fn) {
  var args = []; //储存传到curring函数中的除了fn之外的其他参数，并储存到args函数中

  args = args.concat([].slice.call(arguments, 1));
  return function () {
    if (arguments.length === 0) {
      return fn.apply(this, args);
    } else {
      //将fn中的参数展开，然后再储存到args数组中
      [].push.apply(args, arguments);
    }
  };
}
/*
	intro : function currying defination
	Author : chenchao
	Date : 2019-06-17
*/


; // curry process

function CurryProcess() {
  var initParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = Object.assign({}, initParam);

  var MyCurry = function MyCurry() {
    var curryKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if ((0, _reactPureCheck.Types)(curryKey) !== "function") {
      // release result memory
      var finalRes = Object.assign({}, result);
      result = null;
      return finalRes;
    }

    result = curryKey(result);
    return function (curryResKey) {
      return MyCurry(curryResKey);
    };
  };

  return MyCurry;
}

;